export default __webpack_public_path__ + "static/media/Veterinary.48fabb41.png";